export default {
  meta: {
    title: '新增商圈',
    url: '/sitemap/new' // 埋点用，记录所属模块
  },
};
